var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.payload)?_c('interface-text-popover',{attrs:{"content":_vm.tooltip,"trigger":"hover","placement":"top"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }